import { Pipe, PipeTransform } from '@angular/core';

import { isSolarpowerStation } from '../constants/constants';

@Pipe({ name: 'isSolarpowerStation' })
export class IsSolarpowerStationPipe implements PipeTransform {
  transform(stationId: number) {
    return isSolarpowerStation(stationId);
  }
}
